import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Label,
  Button,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
} from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
import {
  fetchCustomersList,
  fetchSessionsList,
  fetchVehiclesList,
} from "../../../slices/thunks";
import { fetchTaxList } from "../../../slices/TaxMaster/thunk";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { fetchDailyOtherChargesReport } from "../../../slices/OtherCharges.js/thunk";
import Swal from "sweetalert2";

const validationSchema = Yup.object({
  customerIds: Yup.array()
    .min(1, "Customer is required")
    .required("Customer is required"),
});

const OtherCharges = ({ onCloseForm }) => {
  const dispatch = useDispatch();

  const selector = createSelector(
    (state) => state,
    (state) => ({
      taxes: state.TaxMaster.taxes,

      customersList: state.Customer.customers,
      // session: state.Session.sessions,
      vehicles: state.Vehicle.vehicles,
      activeSessions: state.Session.selectedSessionYear,
    }),
  );

  const { customersList, activeSessions, vehicles } = useSelector(selector);

  useEffect(() => {
    dispatch(fetchTaxList({ isPagination: 0 }));
    dispatch(fetchVehiclesList({ isPagination: 0 }));
    dispatch(fetchCustomersList({ isPagination: 0 }));
    // dispatch(fetchSessionsList({ isPagination: 0, isActive: true }));
  }, [dispatch]);

  return (
    <div
      className="page-content d-flex justify-content-center align-items-center"
      style={{ minHeight: "100vh", background: "#f8f9fa" }}
    >
      <div className="w-100" style={{ maxWidth: "1000px" }}>
        <Card className="shadow-sm">
          <CardHeader className="bg-white text-start">
            <h4 className="mb-0">Charges Invoice Report</h4>
          </CardHeader>
          <CardBody>
            <Formik
              initialValues={{
                customerIds: [],
                sessionId: "",
                vehicleIds: [],

                fromDate: "",
                toDate: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                const result = await Swal.fire({
                  icon: "question",
                  title: "Extra Charges Report",
                  text: "Do you want to download the Extra Charges Report?",
                  showCancelButton: true,
                  confirmButtonText: "Download",
                  cancelButtonText: "Cancel",
                  confirmButtonColor: "#28a745",
                  cancelButtonColor: "#6c757d",
                });
                if (result.isConfirmed) {
                  dispatch(fetchDailyOtherChargesReport(values));
                  resetForm();
                  onCloseForm && onCloseForm();
                }
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <Row className="g-3">
                    <FormGroup>
                      <Label className="form-label">Session</Label>
                      {activeSessions &&
                        values.sessionId !== activeSessions?.id &&
                        setFieldValue("sessionId", activeSessions?.id)}
                      <input
                        type="text"
                        className="form-control bg-light"
                        disabled
                        value={activeSessions?.name || ""}
                      />
                    </FormGroup>
                    <Col md={6}>
                      {/* CUSTOMER */}
                      <FormGroup>
                        <Label className="form-label">
                          Customer <span className="text-danger">*</span>
                        </Label>
                        <Select
                          options={[
                            { value: "ALL", label: "All" },
                            ...customersList.map((c) => ({
                              value: c.id,
                              label: c.name,
                            })),
                          ]}
                          value={
                            values.customerIds?.length === customersList.length
                              ? { value: "ALL", label: "All" }
                              : values.customerIds?.length === 1
                                ? {
                                    value: values.customerIds[0],
                                    label:
                                      customersList.find(
                                        (c) => c.id === values.customerIds[0],
                                      )?.name || "",
                                  }
                                : null
                          }
                          onChange={(opt) => {
                            if (opt?.value === "ALL") {
                              setFieldValue(
                                "customerIds",
                                customersList.map((c) => c.id),
                              );
                            } else {
                              setFieldValue(
                                "customerIds",
                                opt ? [opt.value] : [],
                              );
                            }
                          }}
                          placeholder="Select Customer"
                          classNamePrefix="react-select"
                        />
                        <ErrorMessage
                          name="customerIds"
                          component="div"
                          className="text-danger small mt-1"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label className="form-label">From Date</Label>
                        <Flatpickr
                          className="form-control"
                          value={values.fromDate}
                          options={{
                            dateFormat: "d-m-Y",
                          }}
                          onChange={(date) =>
                            // setFieldValue(
                            //   "fromDate",
                            //   date?.[0]?.toISOString().substring(0, 10) || null
                            // )

                            {
                              const fromDateValue = date?.[0]
                                ? (() => {
                                    const d0 = date[0];
                                    const y = d0.getFullYear();
                                    const m = String(
                                      d0.getMonth() + 1,
                                    ).padStart(2, "0");
                                    const dd = String(d0.getDate()).padStart(
                                      2,
                                      "0",
                                    );
                                    return `${dd}-${m}-${y}`;
                                  })()
                                : null;
                              setFieldValue("fromDate", fromDateValue);
                            }
                          }
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      {/* FROM DATE */}
                      <FormGroup>
                        <Label className="form-label">Vehicle</Label>
                        <Select
                          options={[
                            { value: "ALL", label: "All" },
                            ...(vehicles || []).map((v) => ({
                              value: v.id,
                              label: v.vehicleNo,
                            })),
                          ]}
                          onChange={(opt) => {
                            if (opt?.value === "ALL") {
                              setFieldValue(
                                "vehicleIds",
                                vehicles.map((v) => v.id),
                              );
                            } else {
                              setFieldValue(
                                "vehicleIds",
                                opt ? [opt.value] : [],
                              );
                            }
                          }}
                          value={
                            values.vehicleIds?.length === vehicles.length
                              ? { value: "ALL", label: "All" }
                              : values.vehicleIds?.length === 1
                                ? {
                                    value: values.vehicleIds[0],
                                    label:
                                      vehicles.find(
                                        (v) => v.id === values.vehicleIds[0],
                                      )?.vehicleNo || "",
                                  }
                                : null
                          }
                          ge={(opt) => {
                            setFieldValue("vehicleIds", opt?.value || "");
                          }}
                          placeholder="Select Vehicle"
                          isClearable
                          classNamePrefix="react-select"
                        />
                      </FormGroup>

                      {/* TO DATE */}
                      <FormGroup>
                        <Label className="form-label">To Date</Label>
                        <Flatpickr
                          className="form-control"
                          value={values.toDate}
                          options={{
                            dateFormat: "d-m-Y",
                          }}
                          onChange={(date) =>
                            // setFieldValue(
                            //   "toDate",
                            //   date?.[0]?.toISOString().substring(0, 10) || null
                            // )

                            {
                              const toDateValue = date?.[0]
                                ? (() => {
                                    const d0 = date[0];
                                    const y = d0.getFullYear();
                                    const m = String(
                                      d0.getMonth() + 1,
                                    ).padStart(2, "0");
                                    const dd = String(d0.getDate()).padStart(
                                      2,
                                      "0",
                                    );
                                    return `${dd}-${m}-${y}`;
                                  })()
                                : null;

                              setFieldValue("toDate", toDateValue);
                            }
                          }
                        />
                      </FormGroup>
                    </Col>

                    {/* SUBMIT BUTTON */}
                    <Col xs={12} className="mt-3">
                      <div className="d-flex justify-content-center">
                        <Button
                          color="success"
                          className="btn-sm"
                          type="submit"
                        >
                          Download Report
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default OtherCharges;
